module.exports = __webpack_public_path__ + "static/media/dragBtn.281aa486.svg";